export enum LocalesEnum {
  AZ = 'az',
  EN = 'en',
  RU = 'ru'
}
export const locales = [LocalesEnum.AZ, LocalesEnum.EN, LocalesEnum.RU];
export const defaultLocale = LocalesEnum.AZ;
